import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { history } from '../../Helpers';
import { authenticationService } from '../../Services';

import { SelectLanguage } from '../SelectLanguage/SelectLanguage'

import { useTranslation } from 'react-i18next';
import EnglishResourceBundle from './locale/header.en.json'
import FrenchResourceBundle from './locale/header.fr.json'

import './header.css'

export const Header = () => {
    const { t, i18n } = useTranslation();
    i18n.addResourceBundle('en', 'header', EnglishResourceBundle);
    i18n.addResourceBundle('fr', 'header', FrenchResourceBundle);

    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        let userSubscription = authenticationService.currentUser.subscribe(x => setCurrentUser(x));
        return function cleanup() {
            userSubscription.unsubscribe();
          };
    });

    const logout = () => {
        authenticationService.logout();
        history.push('/login');
    }

    return (
        <header className="aform-header py-3 no-print">
            <div className="row flex-nowrap justify-content-between align-items-center">
                <div className="col-4">
                    <Link to="/" className="text-dark logo">aform</Link>
                </div>

                <div className="col-8 d-flex justify-content-end align-items-center">                                
                    <ul className="list-inline buttons">
                        { currentUser && <li className="list-inline-item"><Link className="btn btn-sm" to="/">{t("header:yourRecentActivities")}</Link></li> }
                        <li className="list-inline-item"><SelectLanguage></SelectLanguage></li>
                        <li className="list-inline-item">
                            { currentUser &&
                                <a className="btn btn-sm btn-outline-secondary" href="/#" onClick={logout}>{t("header:logOut")}</a>
                            }
                            {!currentUser &&
                                <Link className="btn btn-sm btn-outline-secondary" to="/login">{t("header:signIn")}</Link>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        </header>
    );
}